module.exports = __webpack_public_path__ + "static/img/ranking1.b9e29d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/ranking1.png
// module id = 41kA
// module chunks = 1